import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnlyNumberDirective } from './directives/numbers-only.directive';
import { OnlyAlphabetDirective } from './directives/alphabets-only.directive';
import { BlockCopyPasteDirective } from './directives/block-copy-paste.directive';
import { PhoneMask } from './pipes/phone-mask.pipe';
import { AlphabetsWithSymbols} from './directives/alphabetsWithSymbols.directive';
import { AutoCapitalizeDirective } from './directives/auto-capitalize.directive';
import { ModalPopupModule } from './modal-popup/modal-popup.module';
import { TranslatePipe } from './pipes/translate.pipe';
import { TranslateApiValuePipe } from './pipes/translate-api-value.pipe';
import { LocaleCurrencyPipe } from './pipes/locale-currency.pipe';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';

@NgModule({
	declarations: [OnlyNumberDirective, OnlyAlphabetDirective, BlockCopyPasteDirective, PhoneMask, AlphabetsWithSymbols, AutoCapitalizeDirective, TranslatePipe, TranslateApiValuePipe, LocaleCurrencyPipe, LanguageSelectorComponent],
	imports: [
		CommonModule,
		ModalPopupModule
	],
	exports: [OnlyNumberDirective, OnlyAlphabetDirective, BlockCopyPasteDirective, PhoneMask, AlphabetsWithSymbols, AutoCapitalizeDirective, ModalPopupModule, TranslatePipe, TranslateApiValuePipe, LocaleCurrencyPipe, LanguageSelectorComponent]
})
export class SharedModule { }
